import { ReactNode } from 'react';
import { IApiResponse } from 'utils/models';

export const sortArrays = ['Source Account:',
  'Destination Account:', 'Narration:', 'Amount:'];

export const sortWithScheduleArrays = ['Source Account:',
  'Destination Account:', 'Narration:', 'Amount:', 'Frequency:', 'Special Date:'];
export const FAB_BANK = { code: '300316', name: 'First Atlantic Bank' };

export interface IExtraFields {
  destinationBankName: string;
  destinationBankCode: string;
  destinationAccountName: string;
  destinationIsExistingBen: boolean;
  beneficiaryId?: number;
  charge?: number;
  transferType: string;
}

export interface IFormValues {
  sourceAccount: string;
  amount: string;
  destinationAccountNo: string;
  narration: string;
  scheduleTransfer?: boolean;
  frequency: string;
  startDate: string
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}

export interface ITransferResponse extends IApiResponse {
  transactionId: number;
}
